import FacilityTypeDropdown from './FacilityTypeDropdown'

export default FacilityTypeDropdown
export { DEFAULT_TITLE as FACILITY_TITLE } from './helpers'
